const NavMobile = (({ jQuery: $ }) => {
    class NavMobile {
        constructor(node) {
            this.$node = $(node);
            this.$nav = this.$node.find('.site-nav__container');
            this.$burger = $('[data-js="site-nav-btn"]');
            this.$searchTrigger = $('[data-js="search-trigger"]');
            this.$header = $('[data-js="site-header"]');
            this.activeClass = 'js-is-active';
            this.initLabel = 'js-initialized';
            this.stickyElements = [this.$nav];

            //state
            this.isOpenState = false;
            this.isStickyState = false;
        }

        sendNavOutOfView() {
            let navWidth = this.$nav.innerWidth();
            this.$nav.css('left', -navWidth);
            $('body').css('overflow', '');

            this.isOpenState = false;
        }

        bringNavIntoView() {
            this.$nav.css('left', 0);
            $('body').css('overflow', 'hidden');

            this.isOpenState = true;
        }

        keepClosed() {
            if (!this.isOpenState) {
                let winWidth = $(window).innerWidth();
                this.$nav.css('left', -winWidth);
                this.sendNavOutOfView();
            }
        }

        toggleNavView() {
            this.isOpenState
                ? this.sendNavOutOfView()
                : this.bringNavIntoView();
        }

        toggleMenu() {
            this.$burger.toggleClass(this.activeClass);
            this.toggleNavView();
        }

        toggleStickyNav(elements) {
            let navHeight = this.$header[0].clientHeight;

            if ($(window).scrollTop() > navHeight) {
                elements.map((element) => {
                    $(element).addClass('sticky');
                });
            } else {
                elements.map((element) => {
                    $(element).removeClass('sticky');
                });
            }
        }

        mobileSearch() {
            if ($(window).innerWidth() < 1024) {
                this.$burger.before(this.$searchTrigger);
            }
        }

        setEventBindings() {
            this.$burger.on('click', this.toggleMenu.bind(this));
            $(window).on('resize', this.keepClosed.bind(this));

            $(window).on(
                'scroll',
                this.toggleStickyNav.bind(this, this.stickyElements)
            );
        }

        getElemByRole(label, $parent = null) {
            const target = label
                ? `[data-js-role="${this.roleLabel}-${label}"]`
                : `[data-js-role="${this.roleLabel}"]`;

            return $parent ? $parent.find(target) : $(target);
        }

        init() {
            this.setEventBindings();
            this.sendNavOutOfView();
            this.mobileSearch();
            this.$nav.addClass(this.initLabel);
        }
    }

    return {
        init({ selector }) {
            return new NavMobile(selector).init();
        },
    };
})(window);

export default Object.create(NavMobile);
